import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle, Instagram, Send } from 'lucide-react';
export function Contact() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
  };
  return <section id="contact" className="py-24 bg-white" data-id="element-88">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-90">
          {/* Contact Info */}
          <div className="w-full lg:w-1/2" data-id="element-91">
            <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-92">
              Зв'яжіться з нами
            </h2>
            <p className="text-brand-dark/70 text-lg mb-10" data-id="element-93">
              Готові зробити замовлення або маєте запитання щодо розміру? Наша
              команда готова допомогти вам з персоналізованим шопінгом.
            </p>

            <div className="space-y-6" data-id="element-94">
              <a href="tel:+380964797313" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-brand-burgundy transition-colors group" data-id="element-95">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-brand-burgundy transition-colors" data-id="element-96">
                  <Phone className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-99">
                    Зателефонувати
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-100">
                    +380 96 479 7313
                  </p>
                </div>
              </a>

              <a href="https://t.me/username" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-[#0088cc] transition-colors group" data-id="element-101">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-[#0088cc] transition-colors" data-id="element-102">
                  <MessageCircle className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-103" />
                </div>
                <div data-id="element-104">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-105">
                    Telegram
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-106">
                    Найшвидша відповідь
                  </p>
                </div>
              </a>

              <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border border-brand-beige hover:border-[#E1306C] transition-colors group" data-id="element-107">
                <div className="w-12 h-12 bg-brand-cream rounded-full flex items-center justify-center group-hover:bg-[#E1306C] transition-colors" data-id="element-108">
                  <Instagram className="w-5 h-5 text-brand-dark group-hover:text-white transition-colors" data-id="element-109" />
                </div>
                <div data-id="element-110">
                  <p className="text-sm text-brand-dark/60 uppercase tracking-wider" data-id="element-111">
                    Instagram
                  </p>
                  <p className="text-lg font-medium text-brand-dark" data-id="element-112">
                    @na.lilu
                  </p>
                </div>
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="w-full lg:w-1/2" data-id="element-113">
            <div className="bg-brand-cream p-8 md:p-10 rounded-3xl" data-id="element-114">
              <h3 className="text-2xl font-serif text-brand-dark mb-6" data-id="element-115">
                Надіслати повідомлення
              </h3>

              {isSubmitted ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="bg-green-50 text-green-800 p-6 rounded-xl text-center border border-green-200" data-id="element-116">
                  <p className="font-medium text-lg mb-2" data-id="element-117">Дякуємо!</p>
                  <p data-id="element-118">
                    Ваше повідомлення надіслано. Ми зв'яжемося з вами найближчим
                    часом.
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-119">
                  <div data-id="element-120">
                    <label htmlFor="name" className="block text-sm font-medium text-brand-dark/80 mb-2" data-id="element-121">
                      Ім'я
                    </label>
                    <input type="text" id="name" required className="w-full px-4 py-3 rounded-xl border border-brand-beige bg-white focus:outline-none focus:ring-2 focus:ring-brand-burgundy/20 focus:border-brand-burgundy transition-all" placeholder="Ваше ім'я" data-id="element-122" />
                  </div>
                  <div data-id="element-123">
                    <label htmlFor="phone" className="block text-sm font-medium text-brand-dark/80 mb-2" data-id="element-124">
                      Номер телефону
                    </label>
                    <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-xl border border-brand-beige bg-white focus:outline-none focus:ring-2 focus:ring-brand-burgundy/20 focus:border-brand-burgundy transition-all" placeholder="+380 XX XXX XXXX" data-id="element-125" />
                  </div>
                  <div data-id="element-126">
                    <label htmlFor="message" className="block text-sm font-medium text-brand-dark/80 mb-2" data-id="element-127">
                      Повідомлення (Необов'язково)
                    </label>
                    <textarea id="message" rows={4} className="w-full px-4 py-3 rounded-xl border border-brand-beige bg-white focus:outline-none focus:ring-2 focus:ring-brand-burgundy/20 focus:border-brand-burgundy transition-all resize-none" placeholder="Мене цікавить..." data-id="element-128"></textarea>
                  </div>
                  <button type="submit" className="w-full py-4 bg-brand-burgundy text-white rounded-xl font-medium hover:bg-brand-burgundy/90 transition-colors flex items-center justify-center gap-2" data-id="element-129">
                    <Send className="w-4 h-4" data-id="element-130" />
                    Надіслати запит
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}